import type { ColorOpacity, PredefinedColor } from "@/types/theme";

export function createThemeColorObject(
  value: PredefinedColor["value"],
  opacity: ColorOpacity = 100,
): PredefinedColor {
  return { cssType: "color", value, opacity };
}
